<template>
  <div>
    <form @submit.prevent="submitted">
      <div class="form-group">
        <text-field
          id="sharedo-url"
          label="Sharedo URL"
          placeholder="Enter the URL for Sharedo."
          v-model="v$.sharedoUrl.$model"
        >
          <template v-slot:validation v-if="v$.sharedoUrl.$error">
            <validation-error v-if="!v$.sharedoUrl.required"
              >You need to enter your Sharedo URL.</validation-error
            >
            <validation-error v-if="!v$.sharedoUrl.url"
              >Invalid URL</validation-error
            >
          </template>
        </text-field>
        <validation-error v-if="error">{{ error }}</validation-error>
        <div class="button-container">
          <button class="btn btn-primary" :disabled="v$.$invalid">
            Login with your Sharedo Account
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { url as validUrl } from "@/validation/url";
import global from "@/global";
import baseUrl from "@/services/common/baseUrlService.js";
import sharedoDiscovery from "@/services/sharedo/sharedoDiscoveryService";
import sharedoSettings from "@/services/sharedo/sharedoSettingsService";
import sharedoCapabilities from "@/services/sharedo/sharedoCapabilitiesService";

const submitted = async function () {
  this.v$.$touch();

  if (this.v$.$invalid) {
    this.submitStatus = "ERROR";
  } else {
    this.submitStatus = "PENDING";

    this.logDebug("Getting oAuth settings from sharedo");

    try {
      const restrictedEnvironments = global.getRestrictedEnvironments();

      const url = this.sharedoUrl.endsWith("/")
        ? this.sharedoUrl.toLowerCase()
        : `${this.sharedoUrl}/`.toLowerCase();

      if (
        restrictedEnvironments.length > 0 &&
        !restrictedEnvironments.includes(url)
      ) {
        this.error =
          "You are not permitted to connect to this instance of Sharedo.";
      } else {
        const settings = await sharedoDiscovery.discover(url);
        sharedoSettings.set(
          Object.assign(
            {
              sharedoApi: url,
              redirectUri: `${baseUrl.get()}/#/oAuthReply`,
            },
            settings
          )
        );

        const capabilities = await sharedoDiscovery.getCapabilities();
        sharedoCapabilities.set(capabilities);

        this.submitStatus = "OK";
        this.logInfo("Acquired oAuth settings from sharedo.");
        this.$store.commit("connected");
      }
    } catch (error) {
      this.logError("Unable to acquire oAuth settings from sharedo.", {
        error,
      });
      this.submitStatus = "OK";
      this.error = "Unable to connect to Sharedo.";
    }
  }
};

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data: function () {
    return {
      sharedoUrl: "",
      error: "",
    };
  },
  validations() {
    return {
      sharedoUrl: {
        required,
        url: validUrl(true),
      },
    };
  },
  methods: {
    submitted,
  },
};
</script>
<style lang="scss" scoped>
.button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
